export const DeleteCommentActionTypes = {
    // TOGGLE_DELETE_COMMENT_PAGE_HIDDEN: 'TOGGLE_DELETE_COMMENT_PAGE_HIDDEN',
    OPEN_DELETE_COMMENT_PAGE: 'OPEN_DELETE_COMMENT_PAGE',
    CLOSE_DELETE_COMMENT_PAGE: 'CLOSE_DELETE_COMMENT_PAGE'
};